<button class="btn__whatsapp px-4" (click)="abrirWhatsapp()">
    <img src="../../../assets/icons/whatsapp.svg" alt="">
    Falar por whatsapp
</button>